import { XKTLoaderPlugin } from "@xeokit/xeokit-sdk";
import { fetchModel } from "./fetchModel";

export const cityLoadModel = (viewer) => {
  console.log(`🔄 Attempting to load city model`);

    // ✅ Prevent duplicate loading
    if (viewer.scene.models["myCityModel"]) {
      console.warn("⚠️ City Model already loaded. Skipping load.");
      return Promise.resolve(viewer.scene.models["myCityModel"]);
    }

  return new Promise((resolve, reject) => {
    const modelUrl = fetchModel("xkt/city.xkt");

    const xktLoader = new XKTLoaderPlugin(viewer);

    const model = xktLoader.load({
      id: "myCityModel",
      src: modelUrl,
      format: "xkt", // Ensure correct format
      edges: true,
      saoEnabled: true,
    });

    model.on("loaded", () => {
      console.log(`✅ Model ${model.id} loaded successfully!`);
      model.visible = false;
      updateCity(viewer,model);
      
      
      resolve(model);
    });

    model.on("error", (error) => {
      console.error(`❌  Error loading city model:`, error);
      reject(error);
    });
    
  })


};


export const updateCity = (viewer, cityModel) => {
  const ifcBaseY = -14;  // IFC model's ground level
  const cityOffsetY = ifcBaseY - cityModel.aabb[1];

  // Apply the translation to the city model
  cityModel.position = [
      cityModel.position[0] + -687555.0518048608,
      cityModel.position[1] + cityOffsetY,
      cityModel.position[2] + 5335673.034500176,
  ];
  const rotationY = 0.034 * (Math.PI / 180); // 2 degrees to radians

  cityModel.rotation = [0, rotationY, 0]; // Rotate 2 degrees around Y-axis

  console.log("✅ Updated City Model Position:", cityModel.position);
};


